import React, { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { Row, Col, Button } from "reactstrap";
import { Popover, Space } from "antd";
import { EditOutlined, SettingOutlined } from "@ant-design/icons";
import QuotationApprovalDrawer from "./QuotationApprovalDrawer";
import AskDocuments from "./AskDocuments";
import FormInput from "../../form-components/InputComponent";
import FormSelect from "../../form-components/SelectComponent";
import FormDatePicker from "../../form-components/DatePicker";
import costCenterApis from "../../../api/master/costCenter";
import deliveryAddressApis from "../../../api/master/deliveryAddress";
import { SelectOptions, DocumentFormValues } from "./types";
import usersApis from "../../../api/master/users";
import { useDispatch, useSelector } from "react-redux";
import SettingsForm from "./SettingsForm";
import contractorsApis from "../../../api/master/contractors";
import sequenceApis from "../../../api/master/sequence";
interface SequenceType {
  module: string;
  level: string;
  siteIds: string[];
}
const RFQGeneralDetails: React.FC = (props: any) => {
  const [sequenceAccess, setSequenceAccess] = useState<SequenceType>();
  const dispatch: any = useDispatch();
  const {
    handleSubmit,
    watch,
    setValue,
    control,
    getValues,
    reset,
    formState: { errors },
  } = useFormContext();

  const [sitesOptions, setSitesOptions] = useState<SelectOptions[]>([]);
  const [contractorOptions, setContractorOptions] = useState<SelectOptions[]>(
    []
  );
  const [costCenterOptions, setCostCenterOptions] = useState<SelectOptions[]>(
    []
  );
  const AllFormDetails = watch();
  const siteIdWatch = watch("siteId");
  const approvalRequired = watch("approvalRequired");
  const supplierDocsRequired = watch("supplierDocsRequired");
  const needByDateType = watch("needByDateType");
  const paymentTermsWatch = watch("paymentTerms");
  const deliveryAddressId = watch("deliveryAddressId");
  const billingAddressId = watch("billingAddressId");
  const [approvals, setApprovals] = useState({
    open: false,
    data: [],
  });
  const [settings, setSettings] = useState({
    open: false,
    data: {
      needByDateType: AllFormDetails.needByDateType || "ORDER_LEVEL",
      deliveryAddressType: AllFormDetails.deliveryAddressType || "ORDER_LEVEL",
      autoRelease: "Y",
      additionalCharges: "Flexible",
      deadlineType: "SOFT",
    },
  });
  const [documentData, setDocumentData] = useState<any>();
  const [documentsPopoverVisible, setDocumentsPopoverVisible] = useState(true);
  const [isAskDocumentsDrawerOpen, setIsAskDocumentsDrawerOpen] =
    useState(false);
  const [deliveryAddressList, setDeliveryAddressList] = useState<any>([]);
  const [deliveryAddressOptions, setDeliveryAddressOptions] = useState<
    SelectOptions[]
  >([]);

  const submitForm = (data: any) => {
    console.log("documentData", documentData);
    setValue("approvalsData", JSON.stringify(approvals));
    if (approvalRequired == "true" && approvals?.data?.length === 0) {
      return;
    }
    if (supplierDocsRequired == "y" && documentData?.documents.length === 0) {
      return;
    } else {
      setValue("documents", documentData);
    }
    props?.next();
  };

  const fetchDeliveryAddress = async () => {
    try {
      const { data, status } = await deliveryAddressApis.fetchDeliveryAddress();
      if (status) {
        let deliveryAddressOptions = data.map((item: any) => ({
          label: item.deliveryLocationName,
          value: item.id.toString(),
        }));
        setDeliveryAddressOptions(deliveryAddressOptions);
        setDeliveryAddressList(data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchDeliveryAddressBySite = async (siteId: any) => {
    try {
      const { data, status } = await deliveryAddressApis.fetchAddressBySite(
        siteId
      );

      if (status) {
        let deliveryAddressOptions = data.map((item: any) => ({
          label: item.deliveryLocationName,
          value: item.id.toString(),
        }));
        setDeliveryAddressOptions(deliveryAddressOptions);
        setDeliveryAddressList(data);
      }
    } catch (error) {
      console.log("Error fetching delivery addresses by site:", error);
    }
  };


  const handleDocumentsSubmit = (data: DocumentFormValues) => {
    setDocumentData(data);
    setDocumentsPopoverVisible(false);
    onAskDocumentsClose();
  };

  const showAskDocumentsDrawer = () => {
    setIsAskDocumentsDrawerOpen(true);
  };

  const onAskDocumentsClose = () => {
    setIsAskDocumentsDrawerOpen(false);
  };

  const fetchSites = async () => {
    try {
      const data = await usersApis.getCurrentUser();
      if (data) {
        let sitesOptions = data?.siteAccessibility?.map((item: any) => ({
          label: item.siteName,
          value: item.siteID.toString(),
        }));
        setSitesOptions(sitesOptions);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchContractor = async () => {
    try {
      const data = await contractorsApis.fetchContractorBySiteId({
        id: siteIdWatch.toString(),
      });
      if (data) {
        let contractorOptions = data.data?.map((item: any) => ({
          label: item?.companyName,
          value: item?.contractorID?.toString(),
        }));
        setContractorOptions(contractorOptions);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchCostCenter = async () => {
    try {
      const { data, status } = await costCenterApis.fetchCostCenter();
      if (status) {
        const costCenterOptions = data.map((item: any) => ({
          label: item.costCenterName,
          value: item.id.toString(),
        }));
        setCostCenterOptions(costCenterOptions);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const ShowAddressPopOver = ({ id, text, options, matchKey }: any) => {
    if (!id) {
      return <></>;
    }

    let address = options?.find((item: any) => item[matchKey] == id);

    if (!address) {
      return <></>;
    }
    return (
      <Popover
        content={
          <ul>
            <li>
              {address?.addressLine1} {address?.addressLine2}
            </li>
            <li>
              {address?.city},{address?.districtName}, {address?.stateName},
              {address?.countryName} - {address?.pincode}
            </li>
          </ul>
        }
        title={address?.deliveryLocationName}
      >
        <a>{text}</a>
      </Popover>
    );
  };



  useEffect(() => {
    if (siteIdWatch) {
      fetchContractor();
      fetchDeliveryAddressBySite(siteIdWatch);
      if (AllFormDetails?.prId) return
      setValue("deliveryAddressId", " ");
    }
  }, [siteIdWatch]);

  useEffect(() => {
    fetchSites();

    fetchCostCenter();
    fetchDeliveryAddress();

    const {
      approvalsData,
      deliveryAddressType,
      needByDateType,
      autoRelease,
      quotationFor,
      supplierDocsRequired,
      documents,
    } = AllFormDetails;
    console.log("AllFormDetails", JSON.stringify(AllFormDetails));

    if (documents) {
      setDocumentData(documents);
    }
    if (approvalsData) {
      setApprovals(JSON.parse(approvalsData));
    }
    if (autoRelease) {
      setValue("autoRelease", autoRelease);
    } else {
      setValue("autoRelease", "Y");
    }
    if (needByDateType) {
      setValue("needByDateType", needByDateType);
    } else {
      setValue("needByDateType", "ORDER_LEVEL");
    }
    if (deliveryAddressType) {
      setValue("deliveryAddressType", deliveryAddressType);
    } else {
      setValue("deliveryAddressType", "ORDER_LEVEL");
    }
    if (supplierDocsRequired === "Y") {
      setDocumentsPopoverVisible(false);
    }

    if (quotationFor) {
      setValue("quotationFor", quotationFor);
    } else {
      setValue("quotationFor", "Material");
    }
  }, []);

  useEffect(() => {
    fetchSequenceAccess();
  }, []);

  const fetchSequenceAccess = async () => {
    try {
      const response = await sequenceApis.fetchSequence();
      const { data } = response;
      const today = new Date();
      const _sequenceAccess = data?.filter(
        (item: any) =>
          item.moduleName === "Quotation" &&
          new Date(item.endDate) > today &&
          item.status === "Active"
      );
      if (_sequenceAccess.length > 0) {
        console.log({
          module: "Quotation",
          level: _sequenceAccess[0].level,
          siteIds: _sequenceAccess?.map((item: any) =>
            item?.siteId?.toString()
          ),
        });

        setSequenceAccess({
          module: "Quotation",
          level: _sequenceAccess[0].level,
          siteIds: _sequenceAccess?.map((item: any) =>
            item?.siteId?.toString()
          ),
        });
      } else
        setSequenceAccess({
          module: "",
          level: "",
          siteIds: [],
        });
    } catch (error: any) {
      console.log(error.response?.data?.message || "An error occurred");
    }
  };
  useEffect(() => { }, [dispatch]);

  const openSettingsForm = () => {
    setSettings((prev) => ({
      ...prev,
      open: true,
    }));
  };

  useEffect(() => {
    setValue("needByDateType", AllFormDetails.needByDateType || "ORDER_LEVEL");
    setValue(
      "deliveryAddressType",
      AllFormDetails.deliveryAddressType || "ORDER_LEVEL"
    );
    setValue("autoRelease", "Y");
    setValue("additionalCharges", "Flexible");
    setValue("deadlineType", "SOFT");
  }, []);

  const handleSettingsSubmit = (updatedSettings: any) => {
    setSettings({
      open: false,
      data: updatedSettings,
    });
    setValue("needByDateType", updatedSettings.needByDateType);
    setValue("deliveryAddressType", updatedSettings.deliveryAddressType);
    setValue("autoRelease", updatedSettings.autoRelease);
    setValue("additionalCharges", updatedSettings.additionalCharges);
    setValue("deadlineType", updatedSettings.deadlineType);
  };

  return (
    <>
      <Row>
        <div
          style={{ justifyContent: "end", display: "flex", marginTop: "-2%" }}
        >
          <Button color="neutral" onClick={openSettingsForm}>
            Settings &nbsp; <SettingOutlined />
          </Button>
        </div>
      </Row>
      <form className="content clearfix" onSubmit={handleSubmit(submitForm)}>
        <Row className="gy-4">
          <Col lg="4">
            <FormSelect
              name="siteId"
              label="Site Name"
              options={sitesOptions}
              required={true}
              placeholder="Select"
              disabled={AllFormDetails?.prId ? true : false}
            />
          </Col>
          {(sequenceAccess?.level == "Site" &&
            !sequenceAccess?.siteIds?.includes(siteIdWatch)) ||
            sequenceAccess?.module == "" ? (
            <Col lg="4">
              <FormInput
                name="rfqId"
                label={`Quotation Number`}
                required={true}
                placeholder="Enter Quotation Number"
              />
            </Col>
          ) : (
            <></>
          )}
          <Col lg="4">
            <FormSelect
              name="quotationFor"
              label="Quotation For"
              defaultValue={{
                label: "Material",
                value: "Material",
              }}
              options={[
                { label: "Material", value: "Material" },
                { label: "Service", value: "Service" },
              ]}
              required={true}
              placeholder="Select Quotation Type"
            />
          </Col>
          <Col lg="4">
            <FormInput
              name="preferredBrands"
              label="Preferred Brands / Make"
              type="text"
              placeholder="Enter Preferred Brands / Make"
            />
          </Col>
          <Col lg="8">
            <FormInput
              name="quotationDescription"
              label="Quotation Description"
              required={true}
              type="text"
              minLength={2}
              maxLength={100}
              placeholder="Enter Description"
            />
          </Col>
          <Col lg="4">
            <FormSelect
              name="costCenter"
              label="Cost Center"
              options={costCenterOptions}
              required={false}
              placeholder="Select Cost Center"
            />
          </Col>
          <Col lg="4">
            <FormDatePicker
              name="lastSubmissionDate"
              label="Last Submission Date"
              required={true}
              placeholder="Select Date"
              minDate={new Date()}
            />
          </Col>
          {/* <Col lg="4">
            <FormSelect
              name="deadlineType"
              label="Submission Type"
              options={[
                { label: "Soft", value: "SOFT" },
                { label: "Hard", value: "HARD" },
              ]}
              required={true}
              placeholder="Select"
            />
          </Col> */}

          <Col lg="4">
            <FormSelect
              name="contractorId"
              label="Contractor"
              options={contractorOptions}
              // required={true}
              placeholder="Select"
            />
          </Col>
          <Col lg="4">
            <FormSelect
              name="approvalRequired"
              label="Approval Required ?"
              disabled={!siteIdWatch}
              options={[
                { label: "Yes", value: "Y" },
                { label: "No", value: "N" },
              ]}
              placeholder="Select"
              required={true}
            />
            <div style={{ display: "none" }}>
              <FormInput name="approvalsData" label="" type="text" />
            </div>
            {approvalRequired == "Y" && (
              <Popover
                content="Click here to set required approvals"
                title="Approval Required"
              >
                <a
                  href="#"
                  className="success"
                  onClick={(e) => {
                    e.preventDefault();
                    setApprovals((pre) => {
                      return {
                        ...pre,
                        open: true,
                      };
                    });
                  }}
                >
                  <EditOutlined /> Set Approvals &nbsp;
                  {approvals?.data?.length == 0 ? (
                    <span className="mandatory">Please set approvals</span>
                  ) : (
                    <></>
                  )}
                </a>
              </Popover>
            )}
          </Col>

          <Col lg="4">
            <FormSelect
              name="supplierDocsRequired"
              label="Require Documents from supplier?"
              options={[
                { label: "Yes", value: "Y" },
                { label: "No", value: "N" },
              ]}
              required={true}
              placeholder="Select"
            />
            {watch("supplierDocsRequired") == "Y" && (
              <Popover
                content="Click here to ask required documents"
                title="Documents Required"
              >
                <a
                  href="#"
                  className="success"
                  onClick={(e) => {
                    e.preventDefault();
                    showAskDocumentsDrawer();
                  }}
                >
                  <EditOutlined /> Ask Required Documents &nbsp;
                  {documentsPopoverVisible ? (
                    <span className="mandatory">Please set documents</span>
                  ) : (
                    <></>
                  )}
                </a>
              </Popover>
            )}
          </Col>

          <Col lg="4">
            <FormSelect
              name="billingAddressId"
              label={`Billing Address${deliveryAddressOptions.length == 0
                  ? "( Empty Billing Address List)"
                  : ""
                }`}
              options={deliveryAddressOptions}
              placeholder={siteIdWatch ? "-Select-" : "Select a site first"}
              disabled={!siteIdWatch}
              popOverOptions={
                <ShowAddressPopOver
                  id={billingAddressId}
                  matchKey="id"
                  options={deliveryAddressList}
                  text="View Selected Billing Address"
                />
              }
              required={true}
              tooltipText="Select the billing address for the Quotation."
            />
          </Col>
          {watch("deliveryAddressType") === "ORDER_LEVEL" && (
            <Col lg="4">
              <FormSelect
                name="deliveryAddressId"
                label="Delivery Address"
                options={deliveryAddressOptions}
                required={true}
                placeholder={siteIdWatch ? "-Select-" : "Select a site first"}
                tooltipText="Select the delivery address for the Quotation."
                disabled={AllFormDetails?.prId ? true : false}
                popOverOptions={
                  <ShowAddressPopOver
                    id={deliveryAddressId}
                    matchKey="id"
                    options={deliveryAddressList}
                    text="View Selected Delivery Address"
                  />
                }
                dropdownRender={(menu) => <>{menu}</>}
              />
            </Col>
          )}

          {needByDateType === "ORDER_LEVEL" && (
            <Col lg="4">
              <FormDatePicker
                name="needByDate"
                label="Need By Date"
                required={true}
                placeholder="Select Date"
                minDate={new Date()}
              />
            </Col>
          )}

          <Col lg="4">
            <FormSelect
              name="paymentTerms"
              label="Payment Terms"
              options={[
                { label: "Cash & Carry", value: "Cash and Carry" },
                // { label: "Advance", value: "Advance" },
                { label: "Credit", value: "Credit" },
              ]}
              required={true}
              placeholder="Select Payment Terms"
              tooltipText="Select the payment terms for the Quotation."
            />
          </Col>
          {paymentTermsWatch == "Credit" && (
            <Col lg="4">
              <FormInput
                name="creditDays"
                type="number"
                label="Credit Days"
                required={true}
                placeholder="Enter Credit Days"
              />
            </Col>
          )}
        </Row>

        <Row className="gy-4 mt-1">
          <Col>
            <Button color="primary" type="submit">
              Next
            </Button>
          </Col>
        </Row>
      </form>
      {settings.open && (
        <SettingsForm
          open={settings.open}
          onClose={() => {
            setSettings((pre) => {
              return {
                ...pre,
                open: false,
              };
            });
          }}
          prId={AllFormDetails?.prId}
          initialValues={settings.data}
          onSubmit={handleSettingsSubmit}
        />
      )}

      {approvals.open && (
        <QuotationApprovalDrawer
          open={approvals.open}
          siteId={siteIdWatch}
          onClose={() => {
            setApprovals((pre) => {
              return {
                ...pre,
                open: false,
              };
            });
          }}
          onSubmit={(data: any) => {
            setApprovals({
              open: false,
              data: data,
            });
          }}
          setApprovalSubmissionStatus={(status: boolean) => { }}
          approvalData={approvals.data} // Pass the current approval data
        />
      )}
      {isAskDocumentsDrawerOpen && (
        <AskDocuments
          open={isAskDocumentsDrawerOpen}
          onClose={onAskDocumentsClose}
          onSubmit={handleDocumentsSubmit}
          documentData={
            documentData || {
              documents: [
                { documentName: "", description: "", mandatory: false },
              ],
            }
          }
        />
      )}
    </>
  );
};

export default React.memo(RFQGeneralDetails);
